import { render } from "./SpotBalanceActionNumberWidgetParams.vue?vue&type=template&id=3e4de4d4"
import script from "./SpotBalanceActionNumberWidgetParams.vue?vue&type=script&lang=js"
export * from "./SpotBalanceActionNumberWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script